import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import * as Styled from './QuantitySelector.styled';

/**
 * Increments or decrements a product variant quantity.
 */
const QuantitySelector = ({
  quantity,
  min,
  onQuantityChange,
  name,
  variantId
}) => {
  const [inputValue, setInputValue] = useState(quantity);

  useEffect(() => {
    setInputValue(quantity);
  }, [quantity]);

  const handleQuantityDecrement = () => {
    const updatedQuantity = quantity - 1;

    if (updatedQuantity >= min) {
      onQuantityChange(updatedQuantity);
    }
  };

  const handleQuantityIncrement = () => {
    onQuantityChange(quantity + 1);
  };

  const handleQuantityEdit = (e) => {
    const {
      currentTarget: { value }
    } = e;
    setInputValue(value);

    const updatedQuantity = parseInt(value, 10);

    if (updatedQuantity >= min) {
      onQuantityChange(updatedQuantity);
    }
  };

  return (
    <Styled.QuantitySelector>
      <Styled.QuantityButton
        name="minus"
        onClick={handleQuantityDecrement}
        data-testid="QuantitySelector_minus-button"
        data-track-label="decrease"
        data-track-property={variantId}
        data-track-value={quantity - 1}
      />
      <Styled.QuantityInput
        data-testid="QuantityInput"
        name={name}
        onChange={handleQuantityEdit}
        onBlur={() => setInputValue(quantity)}
        onWheel={(e) => e.target.blur()}
        value={inputValue}
      />
      <Styled.QuantityButton
        name="plus"
        onClick={handleQuantityIncrement}
        data-testid="QuantitySelector_plus-button"
        data-track-label="increase"
        data-track-property={variantId}
        data-track-value={quantity + 1}
      />
    </Styled.QuantitySelector>
  );
};

QuantitySelector.propTypes = {
  /**
   * Quantity number to display
   */
  quantity: PropTypes.number.isRequired,
  /**
   * Lowest quantity the component supports
   */
  min: PropTypes.number,
  /**
   * callback function to update the quantity
   */
  onQuantityChange: PropTypes.func.isRequired,
  /**
   * unique name for quantity input
   */
  name: PropTypes.string.isRequired,
  /**
   * decoded id of the variant
   */
  variantId: PropTypes.string.isRequired
};

QuantitySelector.defaultProps = {
  min: 0
};

export default QuantitySelector;
